import { render, staticRenderFns } from "./PritingTaslimReport.vue?vue&type=template&id=5d677132&scoped=true"
import script from "./PritingTaslimReport.vue?vue&type=script&lang=js"
export * from "./PritingTaslimReport.vue?vue&type=script&lang=js"
import style0 from "./PritingTaslimReport.vue?vue&type=style&index=0&id=5d677132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d677132",
  null
  
)

export default component.exports